import { useMemo } from "react"

interface TimelineFadeProps {
  before: boolean;
  count?: number;
  width: number;
}

export function TimelineFade({ before, count, width }: TimelineFadeProps) {
  const markers = useMemo(() => {
    const n = count || 12;
    const padding = 24 - width;
    return Array.from(Array(n).keys()).map((i) => {
      const mi = before ? i : (n - i);
      const percentage = mi / n;
      return <div key={`marker-${i}`} className="marker" style={{ opacity: percentage, marginLeft: `${padding}px`, width: `${width}px` }}></div>;
    });
  }, [before, count, width]);
  return <div className="TimelineFade">{markers}</div>;
}
